import { Inject, Injectable } from '@angular/core';
import { ConfigService } from './../../config/config/config.service';
import { DOCUMENT } from '@angular/common';
import {AsyncSubject, BehaviorSubject, Observable, Subject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TealiumhelperService {
    $loaded: BehaviorSubject<boolean>;
    constructor(private config: ConfigService,
                @Inject(DOCUMENT) private _document) {
      (<any>window)['utag_cfg_ovrd'] = { noview: true };
      (<any>window)['utag_data'] = {};

    }
    /**
     * Load utag scripts
     * return behavior subject otherwise
     */
    public loadUtag(): Observable<any> {

      if (this.$loaded) {
        return this.$loaded;
      }

      this.$loaded = new BehaviorSubject(false);
      const rootUrl = this.config.get('tealiumUrl');
      if (rootUrl) {
        const head = this._document.getElementsByTagName('head')[0];
        const script = this._document.createElement('script');
        script.src = rootUrl;
        script.type = 'text/javascript';
        script.async = true;
        // real browsers
        script.onload = () => {
          this.$loaded.next(true);
        };

        // Internet explorer
        (<any>script).onreadystatechange = function () {
          if (this.readyState === 'complete') {
            this.$loaded.next(true);
          }
        };
        head.appendChild(script);
      }
      return this.$loaded;
    }

    /**
     * Ensure values has no typos
     */
    private checkValue(udo, key) {
        switch (typeof udo[key]) {
            case 'object':
                if (Array.isArray(udo[key]) && udo[key].some(k => k === undefined)) {
                    udo[key] = this.cleanArray(udo, key);
                } else {
                    udo[key] = udo[key].length === 0 ? [' '] : udo[key];
                }
                break;
            case 'boolean':
                udo[key] = udo[key] ? 'true' : 'false';
                break;
            case 'undefined':
                udo[key] = ' ';
                break;
            case 'number':
                udo[key] = udo[key] === 0 ? '0' : udo[key];
                break;
        }
    }
  /**
   * Ensure values has no typos
   */
    private cleanArray(udo, key) {
        let i = 0, value;
        const arry = [];
        while (i < udo[key].length) {
            value = udo[key][i] === undefined ? '' : udo[key][i];
            arry.push(value);
            i++;
        }
        return arry;
    }
  /**
   * Ensure values has no typos
   */
    private checkForFalsey(udo, keys?) {
      const udoKeys = Object.keys(udo);
      if (keys) {
        keys.forEach( key => {
          if (udoKeys.some(k => k === key)) {
            this.checkValue(udo, key);
          }
        });
      } else {
        udoKeys.forEach( key => {
          this.checkValue(udo, key);
        });
      }
      return udo;
    }

  /**
   * The main function to send tealium data
   * param tealium_event | type of event link | view
   * param data | data to be sent
   * param cb | a call back function to execute after tag fired
   */
    public track(tealium_event: string, data?: any, cb?: Function) {
      if ((<any>window)['utag'] === undefined) {
        this.loadUtag().subscribe((state) => {
          if (!state) { return; }
          (<any>window)['utag'][tealium_event]( data, cb);
        });
      } else {
        (<any>window)['utag'][tealium_event](data, cb);
      }
    }
    /**
     * wrap utag.view
     * param {type} udo
     * returns {undefined}
     */
    public view(udo, cb?: Function) {
        if (udo.event_type) {
            udo.event_type = '';
        }
        if (udo.event_category) {
            udo.event_category = '';
        }
        this.checkForFalsey(udo);
        this.track('view', udo, cb);
    }
    /**
     * wrap utag.link
     * param {type} udo
     * returns {undefined}
     */
    public link(udo, cb?: Function) {
      this.checkForFalsey(udo);
      this.track('link', udo, cb);
    }

}
